import { NavLink } from "react-router-dom";
import styles from "../../styles/Navbar.module.scss";

const Navbar = () => {
  return (
    <div className={styles.navbar}>
      <div>
        <h4>Riddhi Siddarkar.</h4>
      </div>
      <ul>
        <NavLink
          className={styles.menuitem}
          activeClassName={styles.activenavroute}
          to="/"
          exact
        >
          Work
        </NavLink>
        <NavLink
          className={styles.menuitem}
          activeClassName={styles.activenavroute}
          to="/aboutme"
        >
          About
        </NavLink>
      </ul>
    </div>
  );
};

export default Navbar;
